<template>
  <svg width="42" height="42" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <defs>
      <filter x="-30%" y="-23.3%" width="160%" height="160%" filterUnits="objectBoundingBox" id="a">
        <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="shadowSpreadOuter1" />
        <feOffset dy="2" in="shadowSpreadOuter1" result="shadowOffsetOuter1" />
        <feGaussianBlur stdDeviation="2" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
        <feComposite in="shadowBlurOuter1" in2="SourceAlpha" operator="out" result="shadowBlurOuter1" />
        <feColorMatrix
          values="0 0 0 0 0.356862745 0 0 0 0 0.356862745 0 0 0 0 0.356862745 0 0 0 0.25 0"
          in="shadowBlurOuter1"
        />
      </filter>
      <circle id="b" cx="15" cy="15" r="15" />
    </defs>
    <g fill="none" fill-rule="evenodd">
      <g transform="translate(6 4)">
        <use fill="#000" filter="url(#a)" xlink:href="#b" />
        <circle stroke="#FFF" stroke-width="2" fill="#9F8054" cx="15" cy="15" r="16" />
      </g>
      <path
        d="M24.368 22.795c.96 0 1.734.792 1.751 1.752a1.75 1.75 0 0 1-1.751 1.751 1.75 1.75 0 0 1-1.752-1.751 1.75 1.75 0 0 1 1.752-1.752Zm-6.03 0c.927 0 1.701.741 1.735 1.668.05.96-.707 1.768-1.667 1.818h-.034a1.726 1.726 0 0 1-1.718-1.667 1.762 1.762 0 0 1 1.685-1.819ZM15.039 12c.758 0 1.397.556 1.499 1.297l.168 1.128h10.61c.05 0 .1.017.135.017.37.068.606.421.538.775l-1.094 5.473a1.872 1.872 0 0 1-1.82 1.482H18.07c-.91 0-1.684-.673-1.819-1.566l-1.044-7.107c-.017-.084-.084-.152-.168-.152h-1.364a.676.676 0 0 1-.674-.673c0-.37.303-.674.674-.674Z"
        fill="#FFF"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'IconPoiGrocery',
};
</script>

<style></style>
